<template>
	<Container>
		<Title>
			{{ $t('contratacion') }}
		</Title>
		<div>
			<div class="w-full flex justify-end">
				<div class="input-group pl-5 flex items-center">
					<input v-model="search" @keyup="onChangeSearch()" type="text" class="sm:w-64 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none" placeholder="Buscar" />
					<span>
						<img src="@/assets/img/buscar.svg" />
					</span>
				</div>
				<ButtonBlack>
					<router-link :to="'/' + section" class="text-white no-underline">
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack>
					<router-link :to="'/admin/listado/configuracion'" class="text-white no-underline">
						<div class="flex items-center">
							<span>{{ $t('configuracion') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<div class="input-group pl-5 flex items-center">
					<input v-model="from" :min="this.$moment().subtract(1, 'year').format('YYYY-MM-DD')" :max="this.$moment().format('YYYY-MM-DD')" type="date" class="sm:w-48 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none" placeholder="Desde" />
				</div>
				<div class="input-group pl-5 flex items-center">
					<input v-model="to" :min="this.$moment().subtract(1, 'year').format('YYYY-MM-DD')" :max="this.$moment().format('YYYY-MM-DD')" type="date" class="sm:w-48 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none" placeholder="Hasta" />
				</div>
				<ButtonBlack>
					<a :disabled="downloading" @click="download()" class="text-white no-underline">
						<div class="flex items-center">
							<span v-if="!downloading">{{ $t('export_excel') }}</span
							><span v-if="downloading">...</span>
						</div>
					</a>
				</ButtonBlack>
			</div>
			<ListTable :itemsTitles="itemsTitles" :items="contracts" :section="section" :isAdmin="false" :itemsTable="itemsTable" />
		</div>
	</Container>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		contracts: {
			query: gql`
				query ($search: String) {
					contracts(order_by: { contract_date: desc }, where: { _or: [{ document: { _ilike: $search } }, { name: { _ilike: $search } }, { phone: { _ilike: $search } }] }) {
						id
						document
						name
						phone
						responsable
						delegation
						status
						active
					}
				}
			`,
			update(data) {
				return data.contracts.map(item => ({
					id: item.id,
					document: item.document,
					name: item.name,
					phone: item.phone,
					responsable: item.responsable,
					delegation: item.delegation,
					status: this.$t(item.status),
					edit: true,
					active: item.active,
				}))
			},
		},
	},
	data() {
		return {
			section: 'admin/listado/contrato',
			itemsTable: 'contracts',
			itemsTitles: ['Id', 'CIF/NIF', 'Nombre', 'Telefono', 'Responsable', 'Delegation', 'status'],
			search: '',
			from: this.$moment().subtract(2, 'days').format('YYYY-MM-DD'),
			to: this.$moment().format('YYYY-MM-DD'),
			downloading: false,
		}
	},
	components: {
		ListTable,
	},
	methods: {
		onChangeSearch() {
			this.$apollo.queries.contracts.refetch({
				search: `%${this.search}%`,
			})
		},
		download() {
			if (!this.downloading) {
				this.downloading = true
				this.$axios({
					url: `${process.env.VUE_APP_API_URL}/contracts/export?from=${this.from}&to=${this.to}`,
					method: 'GET',
					responseType: 'blob',
				}).then(response => {
					const fileURL = window.URL.createObjectURL(new Blob([response.data]))
					const fileLink = document.createElement('a')

					fileLink.href = fileURL
					fileLink.setAttribute('download', 'CONTRATOS.xlsx')
					document.body.appendChild(fileLink)

					fileLink.click()
					this.downloading = false
				})
			}
		},
	},
}
</script>
